<template>
  <el-card>
    <div slot="header" class="page-header">
      <div class="page-hedaer">
        <h4 class="page-title">下级代理用户列表</h4>
        <!-- <span class="title-info">(邀请用户，获得其10%的订单佣金)</span> -->
      </div>
      <div>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-s-data"
          @click="showTongJi"
          >报表与排名</el-button
        >
      </div>
    </div>

    <!-- 搜索筛选区域 -->
    <div class="search-bar">
      <el-input
        v-model="searchForm.keyword"
        placeholder="搜索手机号"
        clearable
        class="search-input"
        @keyup.enter.native="handleSearch"
        size="small"
      ></el-input>
      <!-- <span class="search-label">加入时间:</span>
      <el-date-picker
        v-model="searchForm.dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        value-format="yyyy-MM-dd"
        size="small"
        class="date-picker"
      ></el-date-picker> -->
      <el-button
        size="small"
        type="primary"
        icon="el-icon-search"
        @click="handleSearch"
        >搜索</el-button
      >
      <el-button size="small" icon="el-icon-refresh" @click="handleReset"
        >重置</el-button
      >
    </div>

    <el-table :data="users" v-loading="loading">
      <div slot="empty">
        <el-empty description="暂无数据"></el-empty>
      </div>
      <el-table-column label="头像" width="80">
        <template slot-scope="scope">
          <!-- <el-avatar :size="40" :src="scope.row.avatar_url"></el-avatar> -->
          <div class="user-avatar">
            <img src="/images/user.png" alt="" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="账户名"></el-table-column>
      <el-table-column prop="invite_count" label="直邀人数"></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.is_enabled ? 'success' : 'danger'">
            {{ scope.row.is_enabled ? "启用" : "禁用" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="角色">
        <template slot-scope="scope">
          <el-tag :type="getRole(scope.row.role)">{{
            getRoleText(scope.row.role)
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="补贴比例" v-if="can_edit_ratio">
        <template slot-scope="scope">
          <div>
            <span>{{ scope.row.distribution_self_ratio }}%</span>
            <el-button
              type="text"
              @click="
                distribution_self_ratio = scope.row.distribution_self_ratio;
                user_id = scope.row.id;
                showRatioDialog = true;
              "
              >修改</el-button
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="加入时间"></el-table-column>

      <!-- <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="showOrders(scope.row)">
            订单记录
          </el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <el-pagination
      v-if="total > 0"
      style="margin-top: 20px; text-align: right"
      :current-page="page"
      :page-size="pageSize"
      :total="total"
      layout="total, prev, pager, next"
      @current-change="fetchUsers"
    ></el-pagination>
    <el-dialog
      :title="`用户${currentPhone}—订单记录`"
      :visible.sync="ordersDialogVisible"
      width="80%"
    >
      <el-table :data="orders" v-loading="ordersLoading" height="500">
        <el-table-column prop="id" label="订单号" width="300">
          <template slot-scope="{ row }">
            <div>订单编号：{{ row.id }}</div>
            <div>报单时间：{{ row.created_at }}</div>
            <div v-if="row.order">收货时间：{{ row.order.confirm_time }}</div>
            <div>
              跟单状态：
              <el-tag size="small" :type="getStatusType(row.bind_status)">
                {{ getStatusText(row.bind_status) }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" width="600">
          <template slot-scope="{ row }">
            <div v-if="row.order" class="goods-info">
              <el-image
                :src="row.order.item_img"
                class="goods-image"
                fit="cover"
              ></el-image>
              <div class="goods-title">
                <div class="title">{{ row.order.item_title }}</div>
                <div style="font-size: 12px">
                  订单状态：<el-tag
                    size="small"
                    :type="getOrderStatusType(row.order.flow_point)"
                  >
                    {{ getOrderStatusText(row.order.flow_point) }}
                  </el-tag>
                </div>
                <div style="font-size: 12px">
                  支付金额：
                  <span>¥{{ row.order.pay_price }}</span>
                </div>
                <span class="shop-name">店铺:{{ row.order.shop_name }}</span>
              </div>
            </div>
            <div v-else class="goods-info">
              <el-image class="goods-image" fit="cover">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i></div
              ></el-image>
              <div class="goods-title">
                <div>--</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="self_commission" label="代理佣金">
          <template slot-scope="scope"
            >¥{{ fenToYuan(scope.row.self_commission) }}</template
          >
        </el-table-column>
        <el-table-column prop="parent_commission" label="我的佣金">
          <template slot-scope="scope"
            ><span class="text-danger"
              >¥{{ fenToYuan(scope.row.parent_commission) }}</span
            ></template
          >
        </el-table-column>
        <el-table-column prop="settle_status" label="结算状态" width="120">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.bind_status != 1"
              :type="getSettleType(scope.row)"
            >
              {{ getSettleText(scope.row) }}
            </el-tag>
            <div v-else>--</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager" v-if="ordersTotal > 0">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="ordersTotal"
          :current-page="ordersPage"
          :page-size="ordersPageSize"
          @current-change="fetchOrders"
        />
      </div>
    </el-dialog>
    <el-dialog
      title="修改补贴比例"
      :visible.sync="showRatioDialog"
      width="300px"
    >
      <div>
        <div>
          <el-input
            v-model.number="distribution_self_ratio"
            type="number"
            :min="0"
            :max="100"
            placeholder="请输入数字"
          >
            <template slot="append">%</template>
          </el-input>
        </div>

        <div class="withdraw-tip">
          我的分成比例
          <span class="text-danger">{{ 100 - distribution_self_ratio }}</span
          >%
        </div>
      </div>

      <div slot="footer">
        <el-button @click="showRatioDialog = false">取消</el-button>
        <el-button type="primary" :loading="ratioLoading" @click="saveRatio"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <!-- 统计报表 -->
    <el-dialog
      :title="`代理统计报表`"
      :visible.sync="statsDialogVisible"
      width="80%"
    >
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <div style="display: flex; align-items: center">
          <div class="stat-item">
            <div class="stat-label">代理佣金：</div>
            <div class="stat-value">¥{{ fenToYuan(total_commission) }}</div>
          </div>
          <span class="line"></span>
          <div class="stat-item">
            <div class="stat-label">我的分成：</div>
            <div class="stat-value">¥{{ fenToYuan(parent_commission) }}</div>
          </div>
          <span class="line"></span>
          <div class="stat-item">
            <div class="stat-label">有效订单数：</div>
            <div class="stat-value">{{ valid_order_count }}</div>
            <div class="stat-label">单</div>
          </div>
          <span class="line"></span>
          <div class="stat-item">
            <div class="stat-label">无效订单数：</div>
            <div class="stat-value">{{ invalid_order_count }}</div>
            <div class="stat-label">单</div>
          </div>
        </div>
        <div style="display: flex; align-items: center">
          <el-checkbox
            v-model="with_ranking"
            @change="fetchStats(1)"
            label="排名"
            size="small"
            style="margin-right: 20px"
          ></el-checkbox>
          <el-radio-group
            v-model="period_type"
            size="small"
            @change="fetchStats(1)"
          >
            <el-radio-button label="today">今日</el-radio-button>
            <el-radio-button label="yesterday">昨日</el-radio-button>
            <el-radio-button label="seven">7天</el-radio-button>
            <el-radio-button label="month">本月</el-radio-button>
            <el-radio-button label="last_month">上月</el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <el-table :data="statsList" v-loading="statsLoading" height="500">
        <el-table-column
          v-if="with_ranking"
          prop="rank"
          label="名次"
          width="80"
        >
        </el-table-column>
        <el-table-column prop="phone" label="账户"></el-table-column>
        <el-table-column prop="commission" label="代理佣金">
          <template slot-scope="scope"
            >¥{{ fenToYuan(scope.row.commission) }}</template
          >
        </el-table-column>
        <el-table-column prop="parent_commission" label="我的佣金">
          <template slot-scope="scope"
            ><span class="text-danger"
              >¥{{ fenToYuan(scope.row.parent_commission) }}</span
            ></template
          >
        </el-table-column>
        <el-table-column prop="valid_order_count" label="有效订单数">
        </el-table-column>
        <el-table-column prop="invalid_order_count" label="无效订单数">
        </el-table-column>
      </el-table>
      <div class="pager" v-if="statsTotal > 0">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="statsTotal"
          :current-page="statsPage"
          :page-size="statsPageSize"
          @current-change="fetchStats"
        />
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import api from "@/api";

export default {
  name: "SubUsers",
  data() {
    return {
      users: [],
      loading: false,
      page: 1,
      pageSize: 10,
      total: 0,
      searchForm: {
        keyword: "",
        dateRange: [],
      },
      distribution_self_ratio: 0,
      showRatioDialog: false,
      ratioLoading: false,

      // 订单记录弹窗
      ordersDialogVisible: false,
      ordersLoading: false,
      orders: [],
      ordersTotal: 0,
      ordersPage: 1,
      ordersPageSize: 10,
      currentUserId: "",
      currentPhone: null,
      can_edit_ratio: false,

      // 报表记录弹窗
      statsDialogVisible: false,
      statsLoading: false,
      statsList: [],
      statsTotal: 0,
      statsPage: 1,
      statsPageSize: 10,
      period_type: "today",
      with_ranking: true,
      total_commission: 0,
      parent_commission: 0,
      invalid_order_count: 0,
      valid_order_count: 0,
    };
  },
  mounted() {
    this.fetchUsers(1);
  },
  methods: {
    async showOrders(row) {
      this.currentUserId = row.id;
      this.currentPhone = row.phone;
      this.ordersDialogVisible = true;
      this.ordersPage = 1;
      this.fetchOrders(1);
    },
    async fetchOrders(page) {
      this.ordersPage = page;
      this.ordersLoading = true;
      try {
        const { data } = await api.get(
          `/api/admin/users/${this.currentUserId}/orders`,
          {
            params: { page, page_size: this.ordersPageSize },
          }
        );
        this.orders = data.items || [];
        this.ordersTotal = data.total || 0;
      } catch (e) {
        this.$message.error(e?.response?.data?.detail || "加载订单记录失败");
      } finally {
        this.ordersLoading = false;
      }
    },
    async fetchUsers(page) {
      this.loading = true;
      try {
        const params = {
          page,
          page_size: this.pageSize,
        };
        // 添加筛选参数
        if (this.searchForm.keyword) {
          params.keyword = this.searchForm.keyword;
        }
        if (
          this.searchForm.dateRange &&
          this.searchForm.dateRange.length === 2
        ) {
          params.start_date = this.searchForm.dateRange[0];
          params.end_date = this.searchForm.dateRange[1];
        }
        const res = await api.get("/api/users/subordinates", { params });
        this.users = res.data.items.map((u) => ({ ...u, loading: false }));
        if (this.users.length > 0) {
          this.can_edit_ratio = this.users[0].can_edit_ratio;
        }
        this.total = res.data.total;
        this.page = page;
      } catch (e) {
        this.$message.error(e.userMessage || "获取下级用户失败");
      } finally {
        this.loading = false;
      }
    },
    async saveRatio() {
      this.ratioLoading = true;
      try {
        await api.put(`/api/users/${this.user_id}/distribution-ratio`, {
          distribution_self_ratio: this.distribution_self_ratio,
        });
        this.showRatioDialog = false;
        this.fetchUsers(this.page);
        this.$message.success("保存成功");
      } catch (e) {
        this.$message.error(e?.userMessage || "保存失败");
      } finally {
        this.ratioLoading = false;
      }
    },
    handleSearch() {
      this.fetchUsers(1);
    },
    getRole(name) {
      const textMap = {
        user: "info",
        leader: "primary",
        admin: "danger",
      };
      return textMap[name] || "info";
    },
    getRoleText(name) {
      const textMap = {
        user: "普通用户",
        leader: "金牌团长",
        admin: "管理员",
      };
      return textMap[name] || "普通用户";
    },
    handleReset() {
      this.searchForm = {
        keyword: "",
        dateRange: [],
      };
      this.fetchUsers(1);
    },
    async handleEnable(userId) {
      const user = this.users.find((u) => u.id === userId);
      if (!user) return;
      user.loading = true;
      try {
        await api.post(`/api/users/${userId}/enable`);
        user.is_enabled = true;
        this.$message.success("已启用");
      } catch (e) {
        this.$message.error(e.userMessage || "启用失败");
      } finally {
        user.loading = false;
      }
    },

    fenToYuan(fen) {
      return (Number(fen || 0) / 100).toFixed(2);
    },
    getSettleType(data) {
      if (
        (data.settle_status == 1 || data.settle_status == 2) &&
        !data.is_commission_settled
      ) {
        return "primary";
      } else if (data.is_commission_settled) {
        return "success";
      } else if (data.settle_status == 3) {
        return "danger";
      } else {
        return "danger";
      }
    },
    getSettleText(data) {
      if (
        (data.settle_status == 1 ||
        data.settle_status == 2) && !data.is_commission_settled
      ) {
        return "待结算";
      } else if (data.is_commission_settled) {
        return "已结算";
      } else if (data.settle_status == 3) {
        return "不结算";
      } else {
        return "未知";
      }
    },
    getStatusType(status) {
      const statusMap = {
        1: "primary",
        2: "success",
        3: "danger",
      };
      return statusMap[status] || "primary";
    },
    getStatusText(status) {
      const textMap = {
        1: "查询中",
        2: "已跟单",
        3: "已丢单",
      };
      return textMap[status] || status || "未知";
    },
    getOrderStatusType(status) {
      const statusMap = {
        PAY_SUCC: "success",
        CONFIRM: "success",
        SETTLE: "success",
        REFUND: "danger",
      };
      return statusMap[status] || "primary";
    },
    getOrderStatusText(status) {
      const textMap = {
        PAY_SUCC: "已支付",
        CONFIRM: "已收货",
        SETTLE: "已收货",
        REFUND: "已退款",
      };
      return textMap[status] || status || "未知";
    },
    async handleDisable(userId) {
      const user = this.users.find((u) => u.id === userId);
      if (!user) return;
      user.loading = true;
      try {
        await api.post(`/api/users/${userId}/disable`);
        user.is_enabled = false;
        this.$message.success("已禁用");
      } catch (e) {
        this.$message.error(e.userMessage || "禁用失败");
      } finally {
        user.loading = false;
      }
    },

    async showTongJi() {
      this.statsDialogVisible = true;
      this.statsPage = 1;
      this.fetchStats(1);
    },
    async fetchStats(page) {
      this.statsPage = page;
      this.statsLoading = true;
      try {
        const { data } = await api.get(`/api/agent/commission-stats-v2`, {
          params: {
            page,
            page_size: this.statsPageSize,
            period: this.period_type,
            with_ranking: this.with_ranking,
          },
        });
        this.statsList = data.items || [];
        this.statsTotal = data.total || 0;
        this.total_commission = data.total_commission;
        this.parent_commission = data.parent_commission;
        this.invalid_order_count = data.invalid_order_count;
        this.valid_order_count = data.valid_order_count;
      } catch (e) {
        this.$message.error(e?.response?.data?.detail || "加载失败");
      } finally {
        this.statsLoading = false;
      }
    },
  },
};
</script>
<style scoped>
.page-hedaer {
  display: flex;
  align-items: center;
  min-height: 32px;
}
.page-title {
  margin: 0;
}
.title-info {
  margin-left: 5px;
  font-size: 12px;
  color: #909399;
}
.line {
  height: 14px;
  width: 1px;
  background-color: #909399;
  margin: 0 10px;
}
.stat-item {
  text-align: center;
  display: flex;
}

.stat-label {
  font-size: 13px;
  color: #909399;
}

.stat-value {
  font-size: 13px;
  /* font-weight: bold; */
  color: #409eff;
}
.search-bar {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  display: flex;
  align-items: center;
}
.search-label {
  margin-left: 10px;
  color: #606266;
  font-size: 14px;
}
.search-input {
  width: 220px;
}
.search-select {
  width: 140px;
}
.date-picker {
  width: 260px;
}
.user-avatar {
  width: 40px;
  height: 40px;
  background: #eee;
  border-radius: 999px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user-avatar img {
  width: 24px;
  height: 24px;
}

.goods-image {
  width: 70px;
  height: 70px;
  flex-shrink: 0;
}
.goods-info {
  display: flex;
  align-items: stretch;
}
.goods-title {
  padding: 0 10px;
}
.goods-title .title {
  height: 46px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.goods-image >>> .image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 18px;
}

.title-info {
  margin-left: 5px;
  font-size: 12px;
  color: #909399;
}
.text-gray {
  color: #999;
}
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.text-danger {
  color: #f56c6c;
}
.text-success {
  color: #67c23a;
}
.goods-image {
  width: 90px;
  height: 90px;
  flex-shrink: 0;
}
.goods-info {
  display: flex;
  align-items: stretch;
}
.goods-title {
  padding: 0 10px;
}
.goods-title .title {
  height: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.goods-title .shop-name {
  display: block;
  color: #909399;
}
.withdraw-tip {
  color: #909399;
  font-size: 12px;
  margin-top: 5px;
  line-height: 14px;
}
</style>
